<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import uploadFile from "@/views/components/common/form/uploadFile.vue";
import { Input, Row, Col, ButtonGroup, Button } from "view-design";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "usertag",
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "标题",
          name: "name",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "textarea",
          maxlength: 500,
          rules: [{ type: "string", max: 500, message: "超过最大长度" }],
        },
        {
          label: "内容绑定",
          name: "content_ids",
          value: "",
          type: "content_ids",
          // type: "select",
          multiple: true,
          dropList: [],
        },
        // {
        //   label: "标签",
        //   name: "tag",
        //   value: "",
        //   type: "textarea",
        //   maxlength: 500,
        //   rules: [{ type: "string", max: 500, message: "超过最大长度" }],
        //   desc:"回车换行"
        // },
        // { label: '详情', name: 'detail', value: '', type: 'ueditor' },
        // {
        //   label: "是否可评论",
        //   name: "is_open_comment",
        //   value: 1,
        //   type: "switch",
        //   trueValue: 1,
        //   falseValue: 0,
        // },
        {
          label: "是否展示",
          name: "status",
          value: 1,
          type: "switch",
          trueValue: 1,
          falseValue: 0,
        },
      ],
      forms: {},
    };
  },
  created() {
    // this.gettagsDrop();

  },
  methods: {
        initData() {
      // 加载详情数据
      $form.initData(this, {}, (res) => {
        if (res) {
          this.forms = res;
          this.$forceUpdate();
           if (this.forms.is_sys==1) {
           this.items[this.getItemIndex('name')].disabled = 'true'
          }
        }
      });
    },
    gettagsDrop() {
      let q = {
        model: "cases,show,skill",
      };
      $utils.api.load(`contentnotPagelist`, q).then((res) => {
        console.log(res, "222222");
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id.toString();
            xx.name =
              (element.model == "show"
                ? "展厅-"
                : element.model == "cases"
                ? "案例-"
                : element.model == "skill"
                ? "技术-"
                : "") + element.title;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "content_ids") {
              this.items[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
          console.log("dropList content_ids", dropList);
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      this.$refs.form.validate((valid) => {
        console.log("handleSubmit forms", valid, this.forms);
        if (valid) {
          console.log("xxx",typeof this.forms.content_ids)
          if (typeof this.forms.content_ids === 'object') {
          console.log("yyyy")
            this.forms.content_ids = (this.forms.content_ids || []).join(",");
          }
          if (typeof this.forms.content_ids === 'string') {
            this.forms.content_ids = this.forms.content_ids 
          }else{
            this.forms.content_ids = "" 
          }
          $form.handleSubmit(this);
        }
      });
    },
  },
};
</script>
